import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/saifulsafuanmdsani/aaims/src/components/layout.js";
import SEO from "../components/seo";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEO title="SARI" mdxType="SEO" />
    <h1>{`SARI`}</h1>
    <p><a parentName="p" {...{
        "href": "https://drive.google.com/file/d/12910q2ofLEhQh7-Z10F-XISDYBMehEcY/view?usp=sharing"
      }}>{`Clinical management of SARI when COVID-19 is suspected`}</a>{`  `}</p>
    <h2>{`SARI Surveillance Flowchart`}</h2>
    <img src="../SARI_SURVEILLANCE_FLOWCHART.jpg" alt="sari" style={{
      "cssFloat": "left",
      "marginRight": "10px"
    }} />  

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      